import { makeStyles } from '@mui/styles';
// colors
import { colors } from '../../../../../colors';

export const useStyles = makeStyles({
  container: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    padding: '16px',
    backgroundColor: 'white',
  },
  header: {
    display: 'flex',
    flexDirection: 'column',
    fontWeight: 600,
    fontSize: 28,
    lineHeight: '36px',
    color: colors.neutral900,
    gap: '8px',
  },
  headerSubTitle: {
    color: colors.neutral600,
    fontWeight: 500,
    fontSize: '16px',
    lineHeight: '24px',
  },
  blurOverlay: {
    width: '100%',
    height: '100%',
    boxSizing: 'content-box',
    alignSelf: 'stretch',
    // height: '536px',
    backdropFilter: 'blur(3.5px)',
    // backgroundColor: 'red',
    position: 'absolute',
  },
  body: {
    paddingTop: '40px',
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    gap: '24px',
    '& .rsw-editor': {
      // maxHeight: '516px',
      // border: `1px solid ${colors.neutral100} !important`,
      '& .rsw-toolbar': {
        background: `${colors.neutral50} !important`,
        borderBottom: `1px solid ${colors.neutral200} !important`,
      },
      '& .rsw-ce': {
        maxHeight: '536px',
        overflowY: 'auto',
        fontFamily: 'Manrope !important',
        padding: '24px !important',
        '& h1': {
          margin: '0 !important',
          fontSize: '18px !important',
          fontWeight: 'bold !important',
        },
        '& h2': {
          margin: '0 !important',
          fontSize: '16px !important',
          fontWeight: 'bold !important',
        },
        '& p, & ul, & ol': {
          margin: '0 !important',
          fontSize: '14px !important',
        },

      },
      /*    '& .rsw-btn[title="Clear formatting"]': {
        display: 'none !important',
      }, */
      '& .rsw-btn[title="Link"]': {
        display: 'none !important',
      },
      '& .rsw-btn[title="HTML mode"]': {
        display: 'none !important',
      },
      '& .rsw-dd option[value="3"]': {
        display: 'none !important',
      },
    },
  },
  alertBox: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '16px',
    borderRadius: '8px',
    backgroundColor: colors.destructive50,
    border: `1px solid ${colors.destructive300}`,
    maxHeight: '72px',
    fontSize: '14px',
    lineHeight: '20px',
    fontWeight: 600,
    color: colors.neutral700,
  },
  warningBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '8px',
    padding: '16px',
    borderRadius: '8px',
    backgroundColor: colors.neutral50,
    border: `1px solid ${colors.indigo300}`,
    maxHeight: '72px',
    fontSize: '14px',
    lineHeight: '20px',
    fontWeight: 600,
    color: colors.neutral700,
  },
  iconSize: {
    width: '20px',
    height: '20px',
  },
  bold: {
    fontWeight: 700,
  },
  warningBoxContent: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  backBtn: {
    fontSize: '14px',
    lineHeight: '20px',
    fontWeight: 600,
    color: colors.primary600,
    maxHeight: '20px',
    maxWidth: '120px',
    padding: '0px !important',
  },
});
